import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=4c4ecea7"
import script from "./Chat.js?vue&type=script&lang=js&external"
export * from "./Chat.js?vue&type=script&lang=js&external"
import style0 from "./Chat.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports